import React from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useResidenceStore } from '@/stores/residenceStore';
import { useAuthStore } from '@/stores/authStore';

const PLAN_LABELS: Record<string, string> = {
  small: 'Petite copropriété',
  medium: 'Copropriété Moyenne',
  large: 'Grande Copropriété',
};

const PLAN_LOT_LIMITS: Record<string, number> = {
  small: 20,
  medium: 50,
  large: 80,
};

export const PlanAlertBanner: React.FC = () => {
  const navigate = useNavigate();
  const currentResidence = useResidenceStore(state => state.currentResidence);
  const currentUser = useAuthStore(state => state.currentUser);

  if (currentUser?.category !== 'council') return null;

  const planAlert = (currentResidence as any)?.planAlert;
  if (!planAlert) return null;

  const planLabel = PLAN_LABELS[planAlert.plan] || planAlert.plan;
  const lotLimit = PLAN_LOT_LIMITS[planAlert.plan] || 0;

  return (
    <div className="bg-amber-500 text-white">
      <button
        onClick={() => navigate('/residence-settings?tab=subscription')}
        className="flex items-center gap-3 w-full text-left px-4 py-3"
      >
        <div className="w-8 h-8 rounded-full bg-amber-600 flex items-center justify-center flex-shrink-0">
          <AlertTriangle size={16} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm leading-tight">Abonnement à mettre à jour</p>
          <p className="text-xs text-amber-100 mt-0.5">
            {planAlert.activeUsers} utilisateurs actifs · Plan {planLabel} (jusqu'à {lotLimit} lots)
          </p>
        </div>
        <ArrowRight size={18} className="flex-shrink-0" />
      </button>
    </div>
  );
};

export default PlanAlertBanner;
